import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import PhotoGallery, { type GalleryImage } from "@/components/base/PhotoGallery";

export default function StoryGallery({ images }: { images: GalleryImage[] }) {
  if (images.length === 0) return null;

  return (
    <section className="sun-glaze bg-primary-950 py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-30"></div>
      <div className="relative w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
              Moments From the Journal
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-background-50 font-semibold">
            Life, Told Through Photographs
          </h2>
          <p className="mt-5 text-base md:text-lg text-background-200 leading-relaxed">
            A window into the seed banks, fields and courtyards behind our stories. Tap any photo
            to open it full screen.
          </p>
        </Reveal>

        <Reveal delay={100}>
          <PhotoGallery images={images} layout="strip" />
        </Reveal>
      </div>
    </section>
  );
}